import React from 'react';
import PropTypes from 'prop-types';

function AvailableBalanceDetails(props) {
  return (
    <div className="lr-customer-pop zambia-balance-info">
      <div className="lr-customer-pop__modal">
        <div>
          <h2 className="lr-pop-heading"><span>Balance Definitions</span></h2>
          <p className="zambia-balance-info-heading">Available Balance:</p>
          <p className="zambia-balance-info-text">
            The value that can still be dispatched or collected,
            until the credit limit is reached
            (note: if the “Open Orders Amount ” is larger than the
            “Available Balance Amount” more
            payments will be needed to fulfill all the open orders).
          </p>
          <p className="zambia-balance-info-heading"> Open Orders:</p>
          <p className="zambia-balance-info-text">Orders placed but not yet dispatched or invoiced.</p>
          <p className="zambia-balance-info-heading">Outstanding Payments:</p>
          <p className="zambia-balance-info-text">These are the payments required to clear all dues to Lafarge.</p>
          <p className="zambia-balance-info-heading">Amount owed:</p>
          <p className="zambia-balance-info-text">This is the outstanding amount that is owed to Lafarge by customers with a credit facility between 1-30 days and any amount over 30 days that is displayed is expected to be settled before the next purchase.</p>
        </div>
        <div className="lr-button-row">
          <button onClick={props.okButtonClick}><span>OK</span></button>
        </div>
      </div>
    </div>
  );
}

AvailableBalanceDetails.propTypes = {
  user: PropTypes.shape({
    sap_digital_order_balance: PropTypes.node,
  }),
  okButtonClick: PropTypes.func,
};

AvailableBalanceDetails.defaultProps = {
  user: {},
  okButtonClick: {},
};

export default AvailableBalanceDetails;
